import { render, staticRenderFns } from "./InformSettings.vue?vue&type=template&id=ca265ba2&scoped=true"
import script from "./InformSettings.vue?vue&type=script&lang=js"
export * from "./InformSettings.vue?vue&type=script&lang=js"
import style0 from "./InformSettings.vue?vue&type=style&index=0&id=ca265ba2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca265ba2",
  null
  
)

export default component.exports